module.exports = __webpack_public_path__ + "img/Solomon-Islands.60885a5f.png";